import { REAL_ESTATE_API } from '../config';
import { dataUtils } from './data-service-util.js';
import { commonAPIConversion } from './api-conversion-common.js';
import { realEstateAPIConversion } from './api-conversion-real-estate.js';
import axios from 'axios';

// ************************************************
// ****  Get Marketing Campaign Types
// ************************************************
const loadPMarketingCampaignTypes = async function(searchInfo) {
  const url = dataUtils.getSearchUrl(`${REAL_ESTATE_API}/option/marketing_campaign_type`, searchInfo);
  console.log(`[loadPMarketingCampaignTypes] - get call to: [${url}}]`);
  try {
    const response = await axios.get(url);
    const pageInfo = dataUtils.parseVinaEntityPageInfo(response, 'marketing_campaign_type', 'markeingCampaignTypes');
    pageInfo.markeingCampaignTypes = commonAPIConversion.convertOptionListFromAPI(pageInfo.markeingCampaignTypes);
    return pageInfo;
  } catch (error) {
    console.error('[loadPMarketingCampaignTypes] - get call failed - error:');
    console.error(error);
    return {
      successful: false,
      httpStatus: error.response.status,
      markeingCampaignTypes: []
    };
  }
};

// **************************************
// ****  Get All Marketing Campaigns
// **************************************
const getAllMarketingCampaigns = async function(searchInfo) {
  const url = dataUtils.getSearchUrl(`${REAL_ESTATE_API}/marketing_campaign`, searchInfo);
  console.log(`[getAllMarketingCampaigns] - get call to: [${url}}]`);
  try {
    const response = await axios.get(url);
    const pageInfo = dataUtils.parseVinaEntityPageInfo(response, 'marketing_campaign', 'marketingCampaigns');
    pageInfo.marketingCampaigns = realEstateAPIConversion.convertMarketingCampaignListFromAPI(pageInfo.marketingCampaigns);
    return pageInfo;
  } catch (error) {
    console.error('[getAllMarketingCampaigns] - get call failed - error:');
    console.error(error);
    return {
      successful: false,
      httpStatus: error.response.status,
      marketingCampaigns: []
    };
  }
};

// ***********************************************
// ****  Get Marketing Campaign By Campaign Key
// ***********************************************
const getMarketingCampaignByCampaignKey = async function(searchInfo, campaignKey) {
  const url = dataUtils.getSearchUrl(`${REAL_ESTATE_API}/marketing_campaign`, searchInfo, `campaign_key=${campaignKey}`);
  console.log(`[getMarketingCampaignByCampaignKey] get marketing campaign by campaign key: [${campaignKey}] - url:`);
  console.log(url);
  try {
    const response = await axios.get(url);
    const pageInfo = dataUtils.parseVinaEntityPageInfo(response, 'marketing_campaign', 'marketingCampaigns');
    pageInfo.marketingCampaigns = realEstateAPIConversion.convertMarketingCampaignListFromAPI(pageInfo.marketingCampaigns);
    return pageInfo;
  } catch (error) {
    console.error('[getMarketingCampaignByCampaignKey] - get call failed - error:');
    console.error(error);
    return {
      successful: false,
      httpStatus: error.response.status,
      marketingCampaigns: []
    };
  }
};

// **************************************
// ****  Request Resource
// **************************************
const requestResource = async function(origContact) {
  const contact = realEstateAPIConversion.convertContactToAPI(origContact);
  try {
    console.log('[requestResource] processing request - contact:');
    console.log(contact);
    const response = await axios.post(`${REAL_ESTATE_API}/marketing_campaign/process_request`, contact);
    if (response.status != 200) {
      console.error(`failed to request resource - error http status: [${response.status}], message: [${response.message}]`);
      return {
        successful: false,
        httpStatus: response.status,
        errorMessage: response.message
      }
    }
    return {
      successful: true,
      httpStatus: response.status,
      errorMessage: null
    };
  } catch (error) {
    console.error('[requestResource] failed to request resource:');
    console.error(error);
    return {
      successful: false,
      httpStatus: error.response.status,
      errors: error.response.data.errors
    };
  }
};

// ****************************************************************
// ****  Expose API Method Calls to Components
// ****************************************************************
export const realEstateDataSvc = {
  loadPMarketingCampaignTypes,
  getAllMarketingCampaigns,
  getMarketingCampaignByCampaignKey,
  requestResource
};
